/* 🤖 this file was generated by svg-to-ts */
export const matIconFlightLand: {
  name: 'flight-land';
  data: string;
} = {
  name: 'flight-land',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"/></svg>`
};
